import styled, { css } from "styled-components";

import { colorsPalettes, fonts, setFont } from "@similarweb/styles";
import {
    Banner,
    BannerTextContainer,
    BannerSecondaryText,
    BannerCloseContainer,
    BannerImageContainer,
    BannerSectionContainer,
} from "@similarweb/ui-components";

export const defaultStyle = {
    content: {},
    overlay: {
        zIndex: 1060,
    },
};

export const websiteModalDefaultStyle = {
    content: {
        marginTop: "73px",
    },
};


export const StyledButtonsGroup = styled.div`
    display: flex;
`;

export const Footer = styled.div`
    flex-direction: row;
    margin-top: 25px;
    display: flex;
    width: 100%;
    justify-content: space-between;

    button {
        margin-left: 8px;
    }
`;

export const SelectedKeysContainer = styled.div<{ isDropDownOpen: boolean }>`
    height: 245px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    padding-bottom: 16px;
    overflow: auto;
    position: relative;
    z-index: 1;
`;

export const ItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 10px;
`;

interface IsError {
    isError: boolean;
}

export const WebsitesModalAutoComplete = styled.div<IsError>`
    margin-top: 10px;
    ${(props) =>
        props.isError &&
        css`
            border: 1px solid ${colorsPalettes.red[400]};
            border-radius: 3px;
        `}
    & .AutoCompleteContainer {
        & > div:first-child {
            & div:nth-child(2) {
                margin: 0;
                padding-left: 20px;
                padding-bottom: 9px;
            }
        }
    }
    & .input-container {
        padding-top: 12px;
        padding-left: 18px;
        padding-bottom: 8px;

        & .SWReactIcons {
            top: 55%;
            display: flex;
        }
    }

    div:first-child {
        ${(props) =>
            props.isError &&
            css`
                height: auto !important;
            `}
    }

    .SearchInput-container .SearchInput {
        width: calc(100% - 54px);
    }

    .ListItemsContainer {
        position: absolute;
        width: 100%;
        z-index: 2;
        box-sizing: border-box;
    }

    > div > div {
        padding: 0;
        transform: none;
    }
`;

export const WebsiteModalContainer = styled.div`
    overflow: auto;
`;

export const WebsiteModalHeaderContainer = styled.div`
    height: 50px;
`;

export const AutosizeTooltipAnchor = styled.div`
    flex: 1;
    min-width: 0;
`;

export const EditOpportuntiesModalTitle = styled.div`
    height: 18px;
    color: ${colorsPalettes.carbon[400]};
    font-size: 12px;
    margin-bottom: 4px;

    justify-content: space-between;
    display: flex;
`;

export const StyledProTipBanner = styled(Banner)`
    align-items: flex-start;
    margin-top: 20px;
    padding-bottom: 24px;
    padding-top: 0;

    ${BannerSectionContainer} {
        align-items: flex-start;
    }

    ${BannerImageContainer} {
        margin-top: 24px;
    }

    ${BannerTextContainer} {
        margin-left: 16px;
        margin-top: 24px;
    }

    ${BannerSecondaryText} {
        line-height: 24px;
        margin-top: 2px;
    }

    ${BannerCloseContainer} {
        margin-top: 14px;
    }
`;

export const StyledWebsitesContainer = styled.div`
    ${setFont({
        $size: 12,
        $weight: "normal",
        $family: fonts.$robotoFontFamily,
    })};
`;

export const StyledQuotaContainer = styled.div`
    display: flex;
    align-items: center;
    line-height: 16px;
    ${setFont({
        $size: 14,
        $weight: "normal",
        $family: fonts.$robotoFontFamily,
        $color: colorsPalettes.carbon[300],
    })};

    &.isLimit {
        ${setFont({
            $color: colorsPalettes.red.s100,
        })};
    }
`;

export const StyledLimitMessage = styled.div`
    background: ${colorsPalettes.red[100]};
    display: flex;
    border: 1px solid ${colorsPalettes.red[300]};
    margin-bottom: 33px;
    margin-top: 16px;
    padding: 16px;
    border-radius: 4px;

    ${setFont({
        $size: 14,
        $weight: "normal",
        $family: fonts.$robotoFontFamily,
        $color: colorsPalettes.carbon[400],
    })};
`;

export const StyledLegendContainer = styled.div`
    span:nth-child(2) {
        width: 405px;
        text-overflow: ellipsis;
        margin-right: 0;
        text-align: left;
    }
`;
